module.exports = __webpack_public_path__ + "05_glasses_black.200c50ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/05_glasses_black.png
// module id = iau2
// module chunks = 0